import { Divider, Grid, Stack, Typography } from '@mui/material'
import CardInfo from './CardInfo';


const CardInfoWrapper = ({ title, details, handleEditTask,setIsOpenSurveyQuestionDialog  }) => {

    return (
        <div>
            <Stack direction={'row'} alignItems={'center'} sx={{
                px: 2,
                py: 1.5
            }} justifyContent={'space-between'}><Typography
                variant="h6"
            >
                    {title}
                </Typography>
                </Stack>

            <Divider />
            <Grid container sx={{
                py: 1
            }}>
                {details?.map((item) => {
                    return <CardInfo
                        key={item.title}
                        item={item}
                        handleEditTask={handleEditTask}
                        setIsOpenSurveyQuestionDialog={setIsOpenSurveyQuestionDialog}
                    />
                })}
            </Grid>
            
        </div>
    )
}

export default CardInfoWrapper
